import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardAttentionPanel.css";

const DashboardAttentionPanel = ({ summary = {}, todayTasks = [] }) => {
    const waitingReview = todayTasks.filter(
        (task) => task.status === "review"
    ).length;

    const idleEmployees = (summary.available ?? 0);

    const alerts = [
        {
            title:       "Overdue Tasks",
            value:       summary.overdue_tasks ?? 0,
            color:       "#dc2626",
            icon:        "🔴",
            description: "Need immediate attention",
        },
        {
            title:       "Idle Employees",
            value:       idleEmployees,
            color:       "#ea580c",
            icon:        "🟠",
            description: "Currently available without active work",
        },
        {
            title:       "Waiting Review",
            value:       waitingReview,
            color:       "#2563eb",
            icon:        "🔵",
            description: "Tasks waiting for review",
        },
        {
            title:       "Due Today",
            value:       todayTasks.length,
            color:       "#16a34a",
            icon:        "🟢",
            description: "Tasks scheduled for today",
        },
    ];

    return (
        <div className="attention-panel">
            <div className="panel-header">
                <div>
                    <h2>Attention Required</h2>
                    <p>Items that require manager action.</p>
                </div>

                <button>View All</button>
            </div>

            <div className="attention-list">
                {alerts.map((item) => (
                    <div
                        key={item.title}
                        className="attention-item"
                    >
                        <div
                            className="attention-icon"
                            style={{ background: `${item.color}15` }}
                        >
                            {item.icon}
                        </div>

                        <div className="attention-content">
                            <div className="attention-title">
                                {item.title}
                            </div>

                            <div className="attention-description">
                                {item.description}
                            </div>
                        </div>

                        <div
                            className="attention-value"
                            style={{ color: item.color }}
                        >
                            {item.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardAttentionPanel;
